import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'

export function useSignOutMutation(options?: {
  onSuccess?: () => void
  onError?: (err: Error) => void
}) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const auth = getAuth()
      await auth.signOut()
      queryClient.clear()
    },
    ...options,
  })
}
